export default __webpack_public_path__ + "static/media/glowingBulbIcon.922da0fb.svg";